import React, { useState, useEffect, useReducer } from "react";
import axios from 'axios';
import { Button, Table } from 'react-bootstrap';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import ButtonStyle from '../util/ButtonStyle';
import NumberFormat from 'react-number-format';
import format from 'date-fns/format';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

const initialState = {
    name : '',
    phone1 : '',
    phone2 : '',
    phone3 : '',
    memo : '',
}

const initialState2 = {
    center : '',
    location : '',
    name : '',
    phone : '',
    itemName1 : '',
    itemName2 : '',
    price1 : '',
    price2 : ''
}

function reducer(state, {field, value}){
    return {
        ...state,
        [field] : value
    }
}

export default function RefundInfoAdd({match}) {
    const [state, dispatchState] = useReducer(reducer, initialState);
    const pcd = match.params.pcd;
    const [purchaseInfo, setPurchaseInfo] = useState(initialState2);
    const [refundData,setRefundData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [paymentType, setPaymentType] = useState('');
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();

    const onChange = (e) => {
        const re = /^[0-9\b]+$/;
        if(e.target.name == "phone1" || e.target.name == "phone2" || e.target.name == "phone3"){
            if (e.target.value == '' || re.test(e.target.value)) {
                dispatchState({field : e.target.name , value : e.target.value})
            }
        }else{
            dispatchState({field : e.target.name , value : e.target.value})
        }
    }

    const { mcd, cid, refundName, phone1, phone2, phone3, reason, accountBank, accountNum, accountName } = state;
    
    function getPurchaseDetailInfo(){
        axios({
            url : data.url + "/slim/purchase_detail_info",
            method : "post",
            data : {
                sid : 'smartgym',
                pcd : pcd
            }
        }).then(function (res){
            console.log(res.data[0]);
            setPurchaseInfo(res.data[0]);
            dispatchState({field : 'mcd' , value : res.data[0].mcd})
            dispatchState({field : 'cid' , value : res.data[0].cid})
            let method = res.data[0].method;
            switch(method){
                case '1' : setPaymentType('카드(온라인)')
                break;
                case '2' : setPaymentType('현금(계좌)')
                break;
                case '5' : setPaymentType('카드(현장)')
                break;
                case '6' : setPaymentType('현금(현장)')
                break;
                case '9' : setPaymentType('PT 회원')
                break;
                default:
                    console.log('no payment type');
            }
            var year2 = res.data[0].sdate.substring(0, 4);
            var month2 = res.data[0].sdate.substring(4, 6);
            var day2 = res.data[0].sdate.substring(6, 8);
            setStartDate(year2 + '-' + month2 + "-" + day2)

            var year3 = res.data[0].edate.substring(0, 4);
            var month3 = res.data[0].edate.substring(4, 6);
            var day3 = res.data[0].edate.substring(6, 8);
            setEndDate(year3 + '-' + month3 + "-" + day3);

        }).catch(function(error){
            console.log(error);
        })
    }

    function getRefundPriceInfo() {
        let mode = 'server';
        let node_api = 'https://api.smartg.kr:3000'
        if(mode === 'local'){
            node_api = "http://192.168.76.23:3000"
        }
        axios({
            url : node_api + "/sp/refund_money",
            method : "post",
            data : {
                oid : pcd
            }
        }).then(function (result){
            console.log(result.data)
            let res_data = result.data;
            let a = ['origin_price', 'fees', 'use_price', 'use_day', 'refund_price', 'start_date'];
            let b = [];
            a.map((item, index) => {
                res_data.map((i, idx) => {
                    if(i.key === item){
                       b.push(i); 
                    }
                })
            })
            setRefundData(b);
        }).catch(function (error){
            console.log(error);
        })
            
    }

    function handleAdd() {
        if(!refundName){
            alert("이름을 입력해 주세요.")
            return false;
        }
        if(!phone1 || !phone2 || !phone3){
            alert("휴대폰 번호를 입력해주세요.")
            return false;
        }
        if(!reason){
            alert("환불사유를 입력해주세요.")
            return false;
        }
        if(!accountBank || !accountNum || !accountName ){
            alert("환불계좌정보를 입력해 주세요.")
            return false;
        }
        let phone = phone1+phone2+phone3;

        let original_price = refundData[0].val;
        let fees = refundData[1].val;
        let use_price = refundData[2].val;
        let use_day = refundData[3].val;
        let refund_price = refundData[4].val;
        let start_date = refundData[5].val;

        let mode = 'server';
        let node_api = 'https://api.smartg.kr:3000'
        if(mode === 'local'){
            node_api = "http://192.168.76.23:3000"
        }
        let answer = window.confirm('환불신청을 진행하시겠습니끼?')
        if(answer){
            axios({
                url : node_api + "/refund/add_refund",
                method : "post",
                data : {
                    mcd : mcd,
                    cid : cid,
                    pcd : pcd,
                    name : refundName,
                    phone : phone,
                    reason : reason,
                    account_bank : accountBank,
                    account_num : accountNum,
                    account_name : accountName,
                    original_price : original_price,
                    fees : fees,
                    use_price : use_price,
                    use_day : use_day,
                    refund_price : refund_price,
                    start_date : start_date
                }
            }).then(function (response){
                if(response.data.ret !== 'Y'){
                    alert(response.data.msg);
                    return;
                }
                alert("환불 신청이 완료되었습니다.");
                window.location.href = '/refund';
            }).catch(function (error){
                console.log(error);
            })
        }
 
    }
    
    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getPurchaseDetailInfo();
            getRefundPriceInfo();
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3>환불 정보 등록</h3>
            <div className="content-component">
                <div className="content-header">
                </div>
                <div className="content-body client-info">
                <div className="info-table-left text-left">
                <h5>구매정보</h5>
                <Table bordered>
                    <tbody>
                        <tr>
                            <td>가맹점</td>
                            <td>{purchaseInfo.center +" "+ purchaseInfo.location}</td>
                        </tr>
                        <tr>
                            <td>고객명</td>
                            <td>
                                {purchaseInfo.name}
                            </td>
                        </tr>
                        <tr>
                            <td>연락처</td>
                            <td>
                                {purchaseInfo.phone}
                            </td>
                        </tr>
                        <tr>
                            <td>상품</td>
                            <td>
                            <table className="inner-table">
                                <tbody>
                                    <tr>
                                        <td>종목</td>
                                        <td>
                                            {purchaseInfo.itemName1 + " " + purchaseInfo.itemName2}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>판매가</td>
                                        <td>
                                            <NumberFormat value={purchaseInfo.price1} displayType={'text'} thousandSeparator={true} suffix={'원'} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>구매가</td>
                                        <td>
                                            <NumberFormat value={purchaseInfo.price2} displayType={'text'} thousandSeparator={true} suffix={'원'} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>유효기간</td>
                                        <td>
                                            {startDate}
                                        <span>&nbsp;~&nbsp;</span>
                                            {endDate}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </td>
                        </tr>
                        <tr>
                            <td>결제 구분</td>
                            <td>
                                {paymentType}
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <h5>이용정보</h5>
                <Table bordered>
                    <tbody>
                        <tr>
                            <td>이용시작일</td>
                            <td>{refundData[5] ? moment(refundData[5].val).format('YYYY-MM-DD') : ''}</td>
                        </tr>
                        <tr>
                            <td>이용종료일</td>
                            <td>{moment().format('YYYY-MM-DD')}</td>
                        </tr>
                        <tr>
                            <td>이용일</td>
                            <td>
                                {refundData[3] ?  refundData[3].val+"일" : ''}
                            </td>
                        </tr>
                    </tbody>
                </Table>


                <div className="button-container">
                    <ButtonStyle mode="refund" title="환불신청등록" buttonClick={() => handleAdd()}/>
                </div>
                </div>
                <div className="info-table-right">
                    <h5>환불 신청 정보</h5>
                    <Table bordered className="refund-table">
                        <tbody>
                            <tr>
                                <td>고객명</td>
                                <td>
                                    <input type="text" name="refundName" value={refundName} onChange={onChange} className="form-control w-25" />
                                </td>
                            </tr>
                            <tr>
                                <td>휴대전화</td>
                                <td>
                                    <div>
                                        <input type="text" name="phone1" maxLength="3" className="form-control d-inline-block w-25" value={phone1} onChange={onChange}/> -&nbsp;
                                        <input type="text" name="phone2" maxLength="4" className="form-control d-inline-block w-25" value={phone2} onChange={onChange}/> -&nbsp;
                                        <input type="text" name="phone3" maxLength="4" className="form-control d-inline-block w-25" value={phone3} onChange={onChange}/>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>환불사유</td>
                                <td>
                                    <div className="memo">
                                    <textarea name="reason" className="form-control" value={reason} onChange={onChange}>
                                    </textarea>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>환불계좌정보</td>
                                <td>
                                <table className="inner-table">
                                    <tbody>
                                        <tr>
                                            <td>은행명</td>
                                            <td>
                                            <input type="text" name="accountBank" value={accountBank} onChange={onChange} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>계좌번호</td>
                                            <td>
                                            <input type="text" name="accountNum" value={accountNum} onChange={onChange} className="form-control" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>소유주</td>
                                            <td>
                                            <input type="text" name="accountName" value={accountName} onChange={onChange} className="form-control" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                ※ 환불계좌정보를 정확하게 입력해주세요.
                                </td>
                            </tr>
                            <tr>
                                <td>환불예상금액</td>
                                <td>
                                <table className="inner-table">
                                    <tbody>
                                        {
                                            refundData ? refundData.map((item, index) => {
                                                if(index < 5 && index !== 3 ){
                                                    return (
                                                        <tr>
                                                            <td>{item.memo}</td>
                                                            <td style={{width : '150px'}}>
                                                                <NumberFormat value={item.val} displayType={'text'} thousandSeparator={true} suffix={'원'} />    
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            }) : ''
                                        }
                                    </tbody>
                                </table>
                                </td>
                            </tr>
                        </tbody>
                    </Table>

                </div>
                </div>
            </div>
            </div>
            </div>
        </main>
    )
}